import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { User, LoginCredentials, AuthTokens } from '@com.maessa.payroll.frontend/models';

@Injectable({ providedIn: 'root' })
export class AuthApiService extends BaseApiService {
  login(credentials: LoginCredentials): Observable<AuthTokens> {
    return this.post<AuthTokens>(`${this.baseUrl}/auth/login`, credentials);
  }

  refresh(refreshToken: string): Observable<AuthTokens> {
    return this.post<AuthTokens>(`${this.baseUrl}/auth/refresh`, {
      refresh_token: refreshToken,
    });
  }

  getProfile(): Observable<User> {
    return this.get<User>(`${this.baseUrl}/auth/me`);
  }
}
